import React from 'react';
import { PackageIcon } from 'lucide-react';
import { volumes } from '../data/content';
import { Accent, SectionHeading } from './SectionHeading';
export function VolumesSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 pt-4 sm:pb-16" aria-labelledby="volumenes-titulo" data-id="element-195" data-mp="cp104fgtz69z">
      <div className="mx-auto max-w-5xl" data-id="element-196" data-mp="7owekb12flcw">
        <SectionHeading id="volumenes-titulo" badge="Los 6 volúmenes del Kit" badgeIcon={PackageIcon} title={<>
              Cobertura Técnica Integral de <Accent data-id="element-198" data-mp="3c5h5zybaxn4q">la Automatización Moderna</Accent>
            </>} subtitle="6 volúmenes digitales con base científica, protocolos de laboratorio y diagramación técnica, listos para tu clase." data-id="element-197" data-mp="7q7kage2n36n" />

        <ol className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-199" data-mp="2xeqdsp5ssm13">
          {volumes.map(({
          icon: Icon,
          number,
          title,
          description
        }) => <li key={number} className="flex h-full flex-col rounded-xl border border-cream-300/70 bg-cream-50 p-4 transition-[transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-card" data-id="element-200" data-mp="2sels8kq19140">
              <div className="flex items-center gap-2.5" data-id="element-201" data-mp="2j5bmhjpzs149">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-forest-700" data-id="element-202" data-mp="2j5trp5umtpob">
                  <Icon className="h-3.5 w-3.5 text-ember-400" aria-hidden="true" data-id="element-203" data-mp="2o3lhnubpv1pv" />
                </span>
                <span className="text-[0.65rem] font-bold uppercase tracking-[0.14em] text-forest-400" data-id="element-204" data-mp="1qiqymt8q675g">
                  Volumen {String(number).padStart(2, '0')}
                </span>
              </div>
              <h3 className="mt-3 text-sm font-semibold leading-snug text-forest-800" data-id="element-205" data-mp="20h6oytzxhcdw">{title}</h3>
              <p className="mt-2 text-[0.8rem] leading-relaxed text-forest-700/70" data-id="element-206" data-mp="24e2qmsvhxjio">{description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}